import axios from 'axios';

const instance = axios.create({
    // baseURL: 'http://103.226.186.83:920',
    // baseURL: 'http://192.168.1.5:920',
    // baseURL: 'http://192.0.0.97:900',
    // baseURL: 'http://192.0.0.96:900', 
    // baseURL: 'http://103.154.203.190:940', 
    // baseURL: 'http://103.154.203.190:980', 
    // baseURL: 'http://192.168.1.9:980', 
    baseURL: 'https://chenthoor.hrapprova.com:443', 


    headers:{
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'X-Requested-With'
    }
});

// const instance = axios.create({
//     baseURL: 'http://167.86.83.37:900',
//     headers:{
//         'Content-Type': 'application/json',
//         'Access-Control-Allow-Origin': '*',
//         'Access-Control-Allow-Headers': 'X-Requested-With'
//     }
// });

// export const PayslipInstance = axios.create({ //used only for payslip
//     baseURL: 'http://167.86.83.37:910',
//     headers:{
//         'Content-Type': 'application/json',
//         'Access-Control-Allow-Origin': '*',
//         'Access-Control-Allow-Headers': 'X-Requested-With'
//     }
// });

export default instance;